import Vue from 'vue';
import Router from 'vue-router';
import Home from './views/Home.vue';

Vue.use(Router);

export default new Router({
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/registe',
      name: 'registe',
      component: () => import('./views/Registe.vue')
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('./views/Login.vue')
    },
    {
      path: '/market',
      name: 'market',
      component: () => import('./views/Market.vue')
    },
    {
      path: '/market/projectDetail',
      name: 'projectDetail',
      component: () => import('./views/ProjectDetail.vue')
    },
    {
      path: '/vendor',
      name: 'vendor',
      component: () => import('./views/Vendor.vue')
    },
    {
      path: '/vendor/detail',
      name: 'vendorDetail',
      component: () => import('./views/VendorDetail.vue')
    },
    {
      path: '/about',
      name: 'about',
      component: () => import('./views/About.vue')
    }
  ]
});
